import { Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { MarkdownComponent } from 'ngx-markdown';

import type { Extra } from '@valk-nx/compositions/ui-receipt-summary/src/lib/receipt-summary.interface';
import { PricePipe } from '@valk-nx/core/lib/pipes/price/price.pipe';

@Component({
	imports: [PricePipe, TranslatePipe, MarkdownComponent],
	selector: `vp-receipt-summary-extra`,
	templateUrl: './extra.component.html',
})
export class ReceiptSummaryExtraComponent {
	extra = input.required<Extra>();
	currency = input('EUR');
}
